import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar-bg-black',
  standalone: true,
  imports: [],
  templateUrl:
    './../../../../Presentation/components/navbar-bg-black/navbar-bg-black.component.html',
  styleUrl:
    './../../../../Presentation/components/navbar-bg-black/navbar-bg-black.component.scss',
})
export class NavbarBgBlackComponent {}
